import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "square-container"
};
const _hoisted_2 = {
  class: "gallery"
};
const _hoisted_3 = ["src"];
import { ImageApi } from '@/api/ai/image';
import { Search } from '@element-plus/icons-vue';
import { onMounted, reactive, ref } from 'vue';
// TODO @fan：加个 loading 加载中的状态
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const loading = ref(true); // 列表的加载中
    const list = ref([]); // 列表的数据
    const total = ref(0); // 列表的总页数
    const queryParams = reactive({
      pageNo: 1,
      pageSize: 10,
      publicStatus: true,
      prompt: undefined
    });
    /** 查询列表 */
    const getList = async () => {
      loading.value = true;
      try {
        const data = await ImageApi.getImagePageMy(queryParams);
        list.value = data.list;
        total.value = data.total;
      } finally {
        loading.value = false;
      }
    };
    /** 搜索按钮操作 */
    const handleQuery = () => {
      queryParams.pageNo = 1;
      getList();
    };
    /** 初始化 */
    onMounted(async () => {
      await getList();
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_Pagination = _resolveComponent("Pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
        modelValue: queryParams.prompt,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => queryParams.prompt = $event),
        style: {
          "width": "100%",
          "margin-bottom": "20px"
        },
        size: "large",
        placeholder: "请输入要搜索的内容",
        "suffix-icon": _unref(Search),
        onKeyup: _withKeys(handleQuery, ["enter"])
      }, null, 8, ["modelValue", "suffix-icon"]), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "gallery-item"
        }, [_createElementVNode("img", {
          src: item.picUrl,
          class: "img"
        }, null, 8, _hoisted_3)]);
      }), 128))]), _createVNode(_component_Pagination, {
        total: total.value,
        page: queryParams.pageNo,
        "onUpdate:page": _cache[1] || (_cache[1] = $event => queryParams.pageNo = $event),
        limit: queryParams.pageSize,
        "onUpdate:limit": _cache[2] || (_cache[2] = $event => queryParams.pageSize = $event),
        onPagination: getList
      }, null, 8, ["total", "page", "limit"])]);
    };
  }
});